import { useState, useEffect } from 'react';
import { fetchAPI, UrlParams } from '../services/strapi';

function mapResponse(result: any, urlPrefix = "") {
  // const dateList = `${result.attributes.date}`.split('-');
  return {
    id: result.id,
    title: result.attributes.title,
    description: result.attributes.description,
    initial_date:  result.attributes.initial_date,
    final_date: result.attributes.final_date
    // date: dateList.length === 3? `${dateList[0]}` : result.attributes.date
  };
}

export type Search = {
  buscaLivre?: string;
  initialDate?: string;
  finalDate?: string;
}

type apiResponse = {
  data: any[],
  meta: {
		pagination: {
			page: number,
			pageSize: number,
			pageCount: number,
			total: number
		}
	}
}

export type Response = {
  results: any[],
  pagination: {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
	}
}

function mountFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    let filter: any = {};
    filter[fieldTitle] = {};
    filter[fieldTitle][operator] = field;

    array.push(filter);
  }
}

function mountCaseSensitiveFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    const tempArray: any[] = [];
    mountFilter(tempArray, field, fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toUpperCase(), fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toLowerCase(), fieldTitle, operator);

    array.push({
      $or: tempArray
    })
  }
}

function mapFilter(search: Search) {
  let filters: any = {};

  let or: any[] = [];
  if(search.buscaLivre) {
    mountCaseSensitiveFilter(or, search.buscaLivre, 'description');
    mountCaseSensitiveFilter(or, search.buscaLivre, 'title');
    
    filters.$or = or;
  }

  let and: any[] = []
  const finalHour = 'T23:59:59'
  mountFilter(and, search.initialDate, 'initial_date', '$gte');
  mountFilter(and, search.finalDate && search.finalDate + finalHour, 'final_date', '$lte');

  filters.$and = and;

  return filters
}

export function useEvents(search: Search | null = null): Response {
  const initialData: Response = {
    results: [], 
    pagination: {
      page: -1,
      pageCount: -1,
      pageSize: -1,
      total: -1
    }
  }
  const [data, setData] = useState<Response>(initialData);
  
  async function fetchData() {
    let query: UrlParams = {
      populate: "*",
      pagination: {
        page: 1,
        pageSize: 100
      },
      sort: ['initial_date:asc', 'title:asc'],
    };
    if(search) {
      query.filters = mapFilter(search);
    }

    setData(await makeRequest(query));
  }

  useEffect(() => {
    //if(data?.results?.length) return;
    fetchData();
  }, [data.pagination.page]); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
};


export async function getEvents(search: Search | null = null,  page: number = 1): Promise<Response> {
  let query: UrlParams = {
    populate: "*",
    pagination: {
      page: page,
      pageSize: 100
    },
    sort: ['initial_date:asc', 'title:asc'],
  };
  if(search) {
    query.filters = mapFilter(search);
  }
  return await makeRequest(query);
}


async function makeRequest(query: any): Promise<Response> {
  const response: apiResponse = await fetchAPI("/calendar-events", query);
    return {
      results: response.data.map((item: any) => mapResponse(item)),
      pagination: response.meta.pagination
    };
}